var NavTemplates = function() {
    var createAnchor = function() {
        return $('<a></a>')
            .addClass('anchor')
            .addClass('text-white');
    };

    this.modelAnchor = function(submodel) {
        return createAnchor()
            .attr('data-model-nice-name', submodel.modelNiceName)
            .attr('data-model-nice-id', submodel.modelNiceId)
            .attr('data-model-name', submodel.modelName)
            .attr('data-submodel-nice-name', submodel.niceId)
            .attr('data-submodel-name', submodel.name)
            .text(submodel.name);
    };
    
    this.linkOutAnchor = function(url, text) {
        return createAnchor()
            .attr('href', url)
            .text(text);
    };
};

module.exports = new NavTemplates();


//////////////////
// WEBPACK FOOTER
// ./src/interlock/nav/nav-template.js
// module id = 74
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14